import React, { createContext, useState, useEffect, useCallback } from 'react';
import { getCurrentUser, fetchAuthSession } from 'aws-amplify/auth';
import { useDispatch } from 'react-redux';
import { loginSuccess, logout } from '../slices/authSlice';
import { Box, CircularProgress } from '@mui/material';

export const AuthContext = createContext({
  checkAuth: () => Promise.resolve(),
  isLoading: false,
});

export function AuthProvider({ children }) {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const currentUser = await getCurrentUser();
      const session = await fetchAuthSession();
      
      if (currentUser && session) {
        dispatch(loginSuccess({
          user: {
            username: currentUser.username,
            email: currentUser.signInDetails?.loginId,
          },
          token: session.tokens?.idToken?.toString()
        }));
      }
    } catch (error) {
      // Only log specific auth errors, not general unauthorized state
      if (error.name !== 'UserUnAuthenticatedException') {
        console.error('Auth check error:', error);
      }
      dispatch(logout());
    } finally {
      setIsLoading(false);
    }
  }, [dispatch]);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <AuthContext.Provider value={{ checkAuth, isLoading }}>
      {children}
    </AuthContext.Provider>
  );
}